// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as PublicSpecArchivedRouteImport } from './routes/public-spec-archived'
import { Route as CompanySlugLoginRouteImport } from './routes/$companySlug/login'
import { Route as CompanySlugLogoutRouteImport } from './routes/$companySlug/logout'
import { Route as AuthedSplatRouteImport } from './routes/_authed/$'
import { Route as AuthedChromeRouteImport } from './routes/_authed/_chrome'
import { Route as DigitalopsSplatRouteImport } from './routes/digitalops.$'
import { Route as ModsyHubSplatRouteImport } from './routes/modsy-hub.$'
import { Route as ProductsAssetIdRouteImport } from './routes/products/$assetId'
import { Route as PublicSpecSplatRouteImport } from './routes/public-spec/$'
import { Route as AuthedChromeIndexRouteImport } from './routes/_authed/_chrome/index'
import { Route as AuthedChromeAdminRouteImport } from './routes/_authed/_chrome/admin'
import { Route as AuthedChromeDashboardRouteImport } from './routes/_authed/_chrome/dashboard'
import { Route as AuthedChromeSessionRouteImport } from './routes/_authed/_chrome/session'
import { Route as PublicSpecIdSpecIdRouteImport } from './routes/public-spec/id.$specId'
import { Route as SharedSpecificationsSplatRouteImport } from './routes/shared/specifications/$'
import { Route as AuthedChromeCommunitiesIndexRouteImport } from './routes/_authed/_chrome/communities/index'
import { Route as AuthedChromeItemsIndexRouteImport } from './routes/_authed/_chrome/items/index'
import { Route as AuthedChromeItemsItemIdRouteImport } from './routes/_authed/_chrome/items/$itemId'
import { Route as AuthedChromeSpecificationsIndexRouteImport } from './routes/_authed/_chrome/specifications/index'
import { Route as AuthedChromeSpecificationsSpecTypeRouteImport } from './routes/_authed/_chrome/specifications/$specType'
import { Route as AuthedChromeSpecificationsSpecRouteImport } from './routes/_authed/_chrome/specifications/_spec'
import { Route as AuthedChromeSpecsIndexRouteImport } from './routes/_authed/_chrome/specs/index'
import { Route as PublicSpecSpecIdVersionsVersionIdRouteImport } from './routes/public-spec/$specId.versions.$versionId'
import { Route as AuthedChromeCommunitiesInternalCommunityIdFullCommunityIdRouteImport } from './routes/_authed/_chrome/communities/$internalCommunityId.$fullCommunityId'
import { Route as AuthedChromeItemsItemIdEditRouteImport } from './routes/_authed/_chrome/items/$itemId_.edit'
import { Route as AuthedChromeSpecificationsIdSpecIdRouteImport } from './routes/_authed/_chrome/specifications/id.$specId'
import { Route as AuthedChromeSpecsVersionIdSplatRouteImport } from './routes/_authed/_chrome/specs/$versionId.$'
import { Route as AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdRouteImport } from './routes/_authed/_chrome/specifications/_spec/$specId.versions.$versionId'
import { Route as AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdEditRouteImport } from './routes/_authed/_chrome/specifications/_spec/$specId.versions.$versionId_.edit'

const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const PublicSpecArchivedRoute = PublicSpecArchivedRouteImport.update({
            id: '/public-spec-archived',path: '/public-spec-archived',getParentRoute: () => rootRouteImport
          })
const CompanySlugLoginRoute = CompanySlugLoginRouteImport.update({
            id: '/$companySlug/login',path: '/$companySlug/login',getParentRoute: () => rootRouteImport
          })
const CompanySlugLogoutRoute = CompanySlugLogoutRouteImport.update({
            id: '/$companySlug/logout',path: '/$companySlug/logout',getParentRoute: () => rootRouteImport
          })
const AuthedSplatRoute = AuthedSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AuthedRoute
          })
const AuthedChromeRoute = AuthedChromeRouteImport.update({
            id: '/_chrome',getParentRoute: () => AuthedRoute
          })
const DigitalopsSplatRoute = DigitalopsSplatRouteImport.update({
            id: '/digitalops/$',path: '/digitalops/$',getParentRoute: () => rootRouteImport
          })
const ModsyHubSplatRoute = ModsyHubSplatRouteImport.update({
            id: '/modsy-hub/$',path: '/modsy-hub/$',getParentRoute: () => rootRouteImport
          })
const ProductsAssetIdRoute = ProductsAssetIdRouteImport.update({
            id: '/products/$assetId',path: '/products/$assetId',getParentRoute: () => rootRouteImport
          })
const PublicSpecSplatRoute = PublicSpecSplatRouteImport.update({
            id: '/public-spec/$',path: '/public-spec/$',getParentRoute: () => rootRouteImport
          })
const AuthedChromeIndexRoute = AuthedChromeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeAdminRoute = AuthedChromeAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeDashboardRoute = AuthedChromeDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeSessionRoute = AuthedChromeSessionRouteImport.update({
            id: '/session',path: '/session',getParentRoute: () => AuthedChromeRoute
          })
const PublicSpecIdSpecIdRoute = PublicSpecIdSpecIdRouteImport.update({
            id: '/public-spec/id/$specId',path: '/public-spec/id/$specId',getParentRoute: () => rootRouteImport
          })
const SharedSpecificationsSplatRoute = SharedSpecificationsSplatRouteImport.update({
            id: '/shared/specifications/$',path: '/shared/specifications/$',getParentRoute: () => rootRouteImport
          })
const AuthedChromeCommunitiesIndexRoute = AuthedChromeCommunitiesIndexRouteImport.update({
            id: '/communities/',path: '/communities/',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeItemsIndexRoute = AuthedChromeItemsIndexRouteImport.update({
            id: '/items/',path: '/items/',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeItemsItemIdRoute = AuthedChromeItemsItemIdRouteImport.update({
            id: '/items/$itemId',path: '/items/$itemId',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeSpecificationsIndexRoute = AuthedChromeSpecificationsIndexRouteImport.update({
            id: '/specifications/',path: '/specifications/',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeSpecificationsSpecTypeRoute = AuthedChromeSpecificationsSpecTypeRouteImport.update({
            id: '/specifications/$specType',path: '/specifications/$specType',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeSpecificationsSpecRoute = AuthedChromeSpecificationsSpecRouteImport.update({
            id: '/specifications/_spec',path: '/specifications',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeSpecsIndexRoute = AuthedChromeSpecsIndexRouteImport.update({
            id: '/specs/',path: '/specs/',getParentRoute: () => AuthedChromeRoute
          })
const PublicSpecSpecIdVersionsVersionIdRoute = PublicSpecSpecIdVersionsVersionIdRouteImport.update({
            id: '/public-spec/$specId/versions/$versionId',path: '/public-spec/$specId/versions/$versionId',getParentRoute: () => rootRouteImport
          })
const AuthedChromeCommunitiesInternalCommunityIdFullCommunityIdRoute = AuthedChromeCommunitiesInternalCommunityIdFullCommunityIdRouteImport.update({
            id: '/communities/$internalCommunityId/$fullCommunityId',path: '/communities/$internalCommunityId/$fullCommunityId',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeItemsItemIdEditRoute = AuthedChromeItemsItemIdEditRouteImport.update({
            id: '/items/$itemId_/edit',path: '/items/$itemId/edit',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeSpecificationsIdSpecIdRoute = AuthedChromeSpecificationsIdSpecIdRouteImport.update({
            id: '/specifications/id/$specId',path: '/specifications/id/$specId',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeSpecsVersionIdSplatRoute = AuthedChromeSpecsVersionIdSplatRouteImport.update({
            id: '/specs/$versionId/$',path: '/specs/$versionId/$',getParentRoute: () => AuthedChromeRoute
          })
const AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdRoute = AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdRouteImport.update({
            id: '/$specId/versions/$versionId',path: '/$specId/versions/$versionId',getParentRoute: () => AuthedChromeSpecificationsSpecRoute
          })
const AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdEditRoute = AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdEditRouteImport.update({
            id: '/$specId/versions/$versionId_/edit',path: '/$specId/versions/$versionId/edit',getParentRoute: () => AuthedChromeSpecificationsSpecRoute
          })





const AuthedChromeSpecificationsSpecRouteChildren = {
  AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdRoute: AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdRoute,AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdEditRoute: AuthedChromeSpecificationsSpecSpecIdVersionsVersionIdEditRoute
}

const AuthedChromeSpecificationsSpecRouteWithChildren = AuthedChromeSpecificationsSpecRoute._addFileChildren(AuthedChromeSpecificationsSpecRouteChildren)



const AuthedChromeRouteChildren = {
  AuthedChromeAdminRoute: AuthedChromeAdminRoute,AuthedChromeDashboardRoute: AuthedChromeDashboardRoute,AuthedChromeSessionRoute: AuthedChromeSessionRoute,AuthedChromeIndexRoute: AuthedChromeIndexRoute,AuthedChromeItemsItemIdRoute: AuthedChromeItemsItemIdRoute,AuthedChromeSpecificationsSpecTypeRoute: AuthedChromeSpecificationsSpecTypeRoute,AuthedChromeSpecificationsSpecRoute: AuthedChromeSpecificationsSpecRouteWithChildren,AuthedChromeCommunitiesIndexRoute: AuthedChromeCommunitiesIndexRoute,AuthedChromeItemsIndexRoute: AuthedChromeItemsIndexRoute,AuthedChromeSpecificationsIndexRoute: AuthedChromeSpecificationsIndexRoute,AuthedChromeSpecsIndexRoute: AuthedChromeSpecsIndexRoute,AuthedChromeCommunitiesInternalCommunityIdFullCommunityIdRoute: AuthedChromeCommunitiesInternalCommunityIdFullCommunityIdRoute,AuthedChromeItemsItemIdEditRoute: AuthedChromeItemsItemIdEditRoute,AuthedChromeSpecificationsIdSpecIdRoute: AuthedChromeSpecificationsIdSpecIdRoute,AuthedChromeSpecsVersionIdSplatRoute: AuthedChromeSpecsVersionIdSplatRoute
}

const AuthedChromeRouteWithChildren = AuthedChromeRoute._addFileChildren(AuthedChromeRouteChildren)



const AuthedRouteChildren = {
  AuthedSplatRoute: AuthedSplatRoute,AuthedChromeRoute: AuthedChromeRouteWithChildren
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute,PublicSpecArchivedRoute: PublicSpecArchivedRoute,CompanySlugLoginRoute: CompanySlugLoginRoute,CompanySlugLogoutRoute: CompanySlugLogoutRoute,DigitalopsSplatRoute: DigitalopsSplatRoute,ModsyHubSplatRoute: ModsyHubSplatRoute,ProductsAssetIdRoute: ProductsAssetIdRoute,PublicSpecSplatRoute: PublicSpecSplatRoute,PublicSpecIdSpecIdRoute: PublicSpecIdSpecIdRoute,SharedSpecificationsSplatRoute: SharedSpecificationsSplatRoute,PublicSpecSpecIdVersionsVersionIdRoute: PublicSpecSpecIdVersionsVersionIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)